module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag20_1007AT.eafd22a7.jpg";